import api from "./api";

// Admin — tela "🌐 Site Público". GET/PUT de tudo que aparece no site
// externo (slug, slogan, bio, cidade, redes, switch de publicar).

export async function getSitePublico() {
  const { data } = await api.get("/SitePublico/me");
  return data;
}

export async function updateSitePublico(payload) {
  const { data } = await api.put("/SitePublico/me", payload);
  return data;
}
